import { SaveInStorage, GetFromStorage } from '@/vessi.utils';

export default {
	addEmpresas: function(state, empresas){
		state.empresas = state.empresas.concat( empresas );
	},
	resetEmpresas: function(state, empresa){
		state.empresas = [];
		state.selected = empresa;
	},
	select: function(state, empresa){
		if( !!empresa ){
			state.selected = empresa;
			SaveInStorage('emisor_seleccionado', empresa);
		}
	},
	resetSucursales: function(state){
		state.selected.sucursales = [];
	},
	addSucursales: (state, sucursales) => {

		if( Array.isArray(state.selected.sucursales) )
			state.selected.sucursales = state.selected.sucursales.concat(sucursales);
	}
}